import { inject, Injectable } from '@angular/core';
import { PharmacyFamily } from '@services/models/pharmacy-family.model';
import { SettingsService } from '@services/settings.service';
import { SourceFilterOptionsLoader } from '@shared/dataview/options/filter-options.registry';
import { SelectListItem } from '@shared/models/select-list-item';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PharmacyFamiliesOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'pharmacyFamilies';

  private readonly settingsService = inject(SettingsService);

  load(): Observable<SelectListItem[]> {
    return this.settingsService
      .find<PharmacyFamily[]>('pharmacy', 'family', true)
      .pipe(map(families => (families ?? []).map(family => ({ name: family.name, value: family.id }))));
  }
}
